import { Input, Modal } from 'antd';
import { useState } from 'react';

import styles from '../../Containers/DynamicRegistrationWrapper.module.less';

import { Alert } from '$HVUI';
import Button from '$Molecules/Buttons/Button';

const KioskManager = ({ isKiosk, shouldIntl }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [passcode, setPasscode] = useState(null);
    const [showPasscodeError, setShowPasscodeError] = useState(false);

    const handleSubmit = () => {
        setShowPasscodeError(false);
        if (passcode === '8899') {
            postSubmit();
        } else {
            setShowPasscodeError(true);
        }
    };
    const postSubmit = () => {
        setModalVisible(false);
        // cookies have to expire, but four years should be fine for now
        document.cookie = 'kiosk=1;max-age=126144000;path=/';
        // go back to welcome
        window.location.assign('/registration/d/');
    };

    const buttonText = shouldIntl
        ? 'Staff login / inicio de sesión del personal'
        : 'Staff login';

    if (isKiosk) return '';
    return (
        <div className={styles['kiosk-wrapper']}>
            <Button
                el="button"
                kind="secondary"
                text={buttonText}
                onClick={() => {
                    setModalVisible(true);
                }}
                style={{
                    color: 'var(--gray000)',
                    background: 'transparent',
                    marginBottom: 'var(--32px)'
                }}
            />
            <Modal
                title="Enable Kiosk Mode"
                visible={modalVisible}
                destroyOnClose={true}
                centered={true}
                footer={null}
                onCancel={() => {
                    setModalVisible(false);
                }}
            >
                {showPasscodeError && (
                    <Alert
                        role="alert"
                        id="error-kiosk-pass"
                        type="error"
                        message="Invalid passcode."
                        showIcon
                        style={{ marginBottom: '1em' }}
                    />
                )}
                <p>
                    Enter your passcode to enable kiosk mode. This will refresh
                    the page.
                </p>
                <p>
                    <strong>
                        This cannot be undone without clearing cookies.
                    </strong>
                </p>
                <label htmlFor="kiosk-pass">Passcode:</label>
                <Input
                    name="kiosk-pass"
                    id="kiosk-pass"
                    onPressEnter={handleSubmit}
                    onChange={e => setPasscode(e.target.value)}
                    aria-describedby="error-kiosk-pass"
                />
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '1em'
                    }}
                >
                    <Button
                        id="button-submit"
                        kind="primary-narrow"
                        text="Enable"
                        onClick={handleSubmit}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default KioskManager;
